import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { AreaGateReference, GateKeepingCandidate } from './../../../../gate-keeping.model';

@Component({
  selector: 'app-gate-keeper-control-find-element-by-qr',
  templateUrl: './gkc-find-element-by-qr.component.html',
  styleUrls: ['./gkc-find-element-by-qr.component.scss']
})
export class GKCFindElementByQrComponent implements OnDestroy {

  scannerEnabled = false;
  deviceCurrent: MediaDeviceInfo;

  ignoreScanResults = false;

  @ViewChild('scanner', { static: true }) scanner: ZXingScannerComponent;

  @Input() areaGateReference: AreaGateReference;

  @Output() selectionChanged = new EventEmitter<Array<GateKeepingCandidate>>();

  constructor(
    private appServerAPI: AppServerAPI
  ) { }

  ngOnDestroy(): void {
    this.scannerEnabled = false;
  }

  /** wird seitens QRCode Scanner aufgerufen, sobald ein QRCode erkannt und gelesen wurde. */
  scanSuccessHandler(qrCodeText: string) {
    this.ignoreScanResults = true;
    this.executeSearch(qrCodeText);
  }

  scanErrorHandler($event: Error) {
    console.error('Failed to scan', $event);
  }

  onDeviceSelected(device: MediaDeviceInfo) {
    this.deviceCurrent = device;
    this.scannerEnabled = true;
  }

  private executeSearch(qrCodeText: String) {
    const searchParams = {
      qrCode: qrCodeText,
      gateId: this.areaGateReference.id,
      direction: this.areaGateReference.direction
    };
    this.appServerAPI.execute<Array<GateKeepingCandidate>>('/tmc-common/gate-keeper-app/handleQRCode', searchParams).subscribe(response => {
      let candidates = new Array<GateKeepingCandidate>();
      for (let entry of response) {
        candidates.push(new GateKeepingCandidate(entry));
      }
      this.ignoreScanResults = false;
      this.selectionChanged.emit(candidates);
    },
      error => {
        this.ignoreScanResults = false;
      });

    this.selectionChanged.emit(new Array<GateKeepingCandidate>());
  }
}
